import React, { createContext, useContext, useState, useEffect } from 'react';
import pb from '../lib/pocketbaseClient';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      if (pb.authStore.isValid && pb.authStore.model) {
        setUser(pb.authStore.model);
        // Try refreshing full user data, but don't fail if it errors
        try {
          const full = await pb.collection('users').getOne(pb.authStore.model.id, { $autoCancel: false });
          setUser(full);
        } catch (e) {
          console.warn('User refresh skipped:', e?.message);
        }
      } else {
        setUser(null);
      }
      setLoading(false);
    };
    load();

    const unsub = pb.authStore.onChange(() => {
      setUser(pb.authStore.model || null);
    });
    return () => unsub();
  }, []);

  const login = async (email, password) => {
    try {
      const auth = await pb.collection('users').authWithPassword(email, password);
      setUser(auth.record);
      return { success: true, user: auth.record };
    } catch (err) {
      return { success: false, error: err.message };
    }
  };

  const logout = () => {
    pb.authStore.clear();
    localStorage.removeItem('pb_auth');
    setUser(null);
  };

  const value = { user, loading, login, logout, isAuthenticated: !!user };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};
